import React from "react";
import popupimage from "../../assets/popup.svg";
import { Button, Form, Image, Modal } from "react-bootstrap";
import { GetBusinessCategory } from "../../Utils/Api/SignUP";
import { useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ManageSubscriptionAPI } from "../../Utils/Api/MarketPlaceMembershipApi";
import { userId } from "../../Utils/LocalStorage";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import { RotatingLines } from "react-loader-spinner";

const ExploreMarketPlaceModal = ({
  cityId,
  closeModelFuc,
  ApiCallFuc,
  MarketMembershipAPICallFuc,
  classN,
  ...props
}) => {
  const [buCategory, setBuCategory] = useState([]);
  const [categorySelect, setCategorySelect] = useState("");
  const [loading, setLoading] = useState(false);
  //   const [selectFlag, setSelectFlag] = useState(false);

  const buid = parseInt(userId());

  const navigate = useNavigate();

  const onCategorySelect = (e) => {
    let val = e.target.value;
    setCategorySelect(val);
    // setSelectFlag(true);
  };

  const GetBusinessCategoryInfo = async () => {
    const data1 = {
      city_id: cityId,
    };
    const businessCategory = await GetBusinessCategory(data1, () => {
      navigate("/");
    });
    if (businessCategory.status === 429) {
      setLoading(true);
      toast.error(businessCategory.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      setBuCategory(businessCategory.data);
    }
  };

  const ApplyHandlerAPI = async (applyStatus) => {
    const data = {
      bu_id: buid,
      city_id: cityId,
      category_id: parseInt(categorySelect),
      action: applyStatus,
    };
    setLoading(true);
    const ManageSubscriptionRes = await ManageSubscriptionAPI(data, () => {
      navigate("/");
    });

    if (ManageSubscriptionRes.success === true) {
      toast.success("Applied Sucessfully", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      closeModelFuc(false);
      setCategorySelect("");
      ApiCallFuc();
      MarketMembershipAPICallFuc();
      setLoading(false);
    } else if (ManageSubscriptionRes.status === 429) {
      setLoading(true);
      toast.error(ManageSubscriptionRes.message, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } else {
      toast.error(ManageSubscriptionRes.message, {
        position: "top-center",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    }
  };

  const ApplyMarketPlaceHandler = () => {
    ApplyHandlerAPI("apply");
  };

  const CancelHandler = () => {
    closeModelFuc(false);
    setCategorySelect("");
  };

  useEffect(() => {
    GetBusinessCategoryInfo();
  }, [cityId]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="popup-modal exploreMarketplace"
    >
      {/* {loading ? <Loader /> : ""} */}
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Image className="applymktImage" loading="lazy" src={popupimage} />
        <Form.Group className="mb-0" controlId="formBasicEmail">
          <div style={{ padding: "1.5rem 1rem 0.5rem 1rem" }}>
            {" "}
            <Form.Label className="form-label-custom">
              Category <span className="star-required">*</span>
            </Form.Label>
            <Form.Select
              aria-label="Default select example"
              className="custom-select"
              onChange={onCategorySelect}
              value={categorySelect}
            >
              <option>Select Category</option>
              {buCategory?.length > 0 ? (
                buCategory.map((val) => {
                  return (
                    <option value={val.category_id}>{val.category_name}</option>
                  );
                })
              ) : (
                <option value="0">{"No categories"}</option>
              )}
            </Form.Select>
          </div>
          <p className="py-3">
            Are you sure you want to apply for this Marketplace?
          </p>
          <div className="text-center small-btns d-flex">
            <Link onClick={CancelHandler}>Cancel</Link>
            <Button
              onClick={ApplyMarketPlaceHandler}
              variant="primary"
              type="submit"
              className={classN}
            >
              {loading === true ? (
                <RotatingLines strokeColor="white" visible={true} />
              ) : (
                "Yes"
              )}
            </Button>
          </div>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
};

export default ExploreMarketPlaceModal;
